const Backsound = () => import(/* webpackChunkName: "elearning" */ '@/views/private/AKE/backsound-sound/Index.vue')
const AKE = () => import(/* webpackChunkName: "elearning" */ '@/views/private/AKE/music-backsound/Index.vue')
const Music = () => import(/* webpackChunkName: "setting" */ '@/views/private/AKE/music/Index.vue')
const Icon = () => import(/* webpackChunkName: "setting" */ '@/views/private/AKE/icon/Index.vue')


const routes = [
  {
    path: "/,",
    name: ",",
    component: AKE,
    meta: {
      title: "AKE"
    },
    children: [
      {
        path: "/ake/music",
        name: "AKE Music",
        component: Music,
        meta: {
          title: "Musik AKE"
        }
      },
      {
        path: "/ake/music/backsound-sound",
        name: "AKE Backsound",
        component: Backsound,
        meta: {
          title: "Backsound AKE"
        }
      },
    ]
  },
  {
    path: "/ake/icon",
    name: "AKE Icon",
    component: Icon,
    meta: {
      title: "Icon AKE"
    }
  }
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})